<template>
  <div class="plants-search-app">
    <div class="seo-sticky-shell">
      <PlantNavbar />
    </div>
    <PlantContributorPopup />
    <main id="main-content">
      <section class="section plants-seo-intro" aria-labelledby="intro-heading">
        <h2 class="visually-hidden" id="intro-heading">{{ $t('site_title') }}</h2>
        <p class="plants-seo-intro__lead">{{ $t('site_seo_text') }}</p>
      </section>
      <PlantPlacementBanner :banner="introBanner" />
      <PlantForm />
      <PlantPagination class="plants-pagination" />
      <PlantCards />
      <PlantPagination class="plants-pagination" />
      <PlantReportInfo />
    </main>
    <PlantFooter />
    <PlantModal />
    <PlantPopupAd />
  </div>
</template>

<script>
import PlantCards from './components/PlantCards.vue'
import PlantForm from './components/PlantForm.vue'
import PlantNavbar from './components/PlantNavbar.vue'
import PlantFooter from './components/PlantFooter.vue'
import PlantPagination from './components/PlantPagination.vue'
import PlantModal from './components/PlantModal.vue'
import PlantReportInfo from './components/PlantReportInfo.vue'
import PlantContributorPopup from './components/PlantContributorPopup.vue'
import PlantPlacementBanner from './components/PlantPlacementBanner.vue'
import PlantPopupAd from './components/PlantPopupAd.vue'
import { resolveWatchoutApiRoot } from '@/utils'

const WATCHOUT_API = resolveWatchoutApiRoot()

export default {
  name: 'App',
  components: {
    PlantNavbar,
    PlantForm,
    PlantCards,
    PlantFooter,
    PlantPagination,
    PlantModal,
    PlantReportInfo,
    PlantContributorPopup,
    PlantPlacementBanner,
    PlantPopupAd
  },
  data () {
    return {
      banners: {}
    }
  },
  computed: {
    introBanner () {
      return this.banners.plants_intro || null
    }
  },
  created () {
    const requestURL = new URL(WATCHOUT_API + 'api/banners')
    requestURL.searchParams.set('product', 'plants4pets')
    const requestedBannerId = new URLSearchParams(window.location.search).get('banner')
    if (requestedBannerId) {
      requestURL.searchParams.set('banner', requestedBannerId)
    }
    fetch(requestURL.toString())
      .then((response) => response.ok ? response.json() : {})
      .then((banners) => {
        this.banners = banners || {}
      })
      .catch(() => {})
  }
}
</script>
